import HXTab from "./HXTab";
import Tabs from "@mui/material/Tabs";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { CopyIcon } from "./CopyTextFieldView.styles";
import { HXButton } from "./HXButton";
import { HXSimpleDialog } from "./HXSimpleDialog";
import { FlexRowDiv } from "./common.styles";
const headerPaddingLeft = 80;
export const Header = styled.div `
    padding-left: ${headerPaddingLeft}px;
    padding-right: 80px;
    height: 64px;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.black_12};
    font-size: ${fontSizes.STANDARD};
    justify-content: space-between;
`;
export const CobrandedLogo = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const CompanyLogo = styled.img `
    height: 23.56px;
    object-fit: contain;
    cursor: ${(props) => (props.disabled ? undefined : "pointer")};
`;
export const OrgLogoImage = styled.img `
    display: block;
    object-fit: contain;
    height: 32px;
`;
export const HeaderTabs = styled(Tabs) `
    margin-left: ${24}px;
    flex-grow: 1;
    flex-shrink: 0;

    & .MuiTabs-indicator {
        display: none;
    }
`;
export const HeaderTab = styled(HXTab) `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const Account = styled.div `
    display: flex;
    align-items: center;
    gap: 80px;
`;
export const PreLoginText = styled.div `
    line-height: 100%;
`;
export const CtasContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
`;
export const RightHandItems = styled(FlexRowDiv) `
    gap: 24px;
`;
export const InviteButton = styled(HXButton) `
    background: linear-gradient(135deg, ${colors.accents_gradient_start} 0%, ${colors.accents_sunset} 100%);
    color: black;
    line-height: normal;
    padding-top: 8px;
    padding-bottom: 8px;
`;
export const CopyInvitationLinkButton = styled(HXButton).attrs({
    startIcon: React.createElement(CopyIcon),
    secondary: true,
}) `
    align-self: stretch;
    justify-content: flex-start;
    font-weight: ${fontWeights.NORMAL};
    background-color: ${colors.white_background};
`;
export const PatientInvitationDialog = styled((HXSimpleDialog)) `
    & .MuiPaper-root {
        width: 600px;
    }

    & .MuiDialogContent-root > * {
        width: 100%;
    }
`;
